import React from 'react';
import { CardText, NavCard, NavDivider, SubNav } from './NavList.styles';
import ContextualMenu from './ContextualMenu';

const KpiElement = ({
	cardTitle,
	Icon,
	changeKey,
	onClickEvent,
	isChild,
	showModuleInfo,
	handleModuleInformation,
	handleModuleDelete,
}) => {
	return (
		<NavCard onClick={() => onClickEvent(changeKey)}>
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					{isChild && (
						<ContextualMenu
							showModuleInfo={showModuleInfo}
							handleModuleInformation={handleModuleInformation}
							id={changeKey}
							moduleName={cardTitle}
							handleModuleDelete={handleModuleDelete}
						/>
					)}
				</div>
				<SubNav>
					<Icon />
					<NavDivider />
					<CardText data-item={cardTitle}>{cardTitle}</CardText>
				</SubNav>
			</div>
		</NavCard>
	);
};

const NavList = ({
	navArray,
	setContent,
	isChild,
	showModuleInfo,
	handleModuleInformation,
	handleModuleDelete,
}) => {
	return (
		<>
			{navArray.map(data => (
				<>
					<KpiElement
						onClickEvent={setContent}
						changeKey={data.key}
						cardTitle={data.title}
						Icon={data.icon}
						isChild={isChild}
						showModuleInfo={showModuleInfo}
						handleModuleInformation={handleModuleInformation}
						handleModuleDelete={handleModuleDelete}
					/>
				</>
			))}
		</>
	);
};

export default NavList;
